import {
    Alert,
    Button,
    Col,
    Container, Icon,
    Row,
    TextArea
} from "design-react-kit";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { properties } from "../../../config/properties";

// Stili presi dal componente FormModificaRuolo per coerenza visuale
const styles = {
    formContainer: {
        padding: '2rem',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        border: '1px solid #ddd'
    },
    formTitle: {
        marginBottom: '1.5rem',
        color: '#333',

        paddingBottom: '0.5rem'
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem' // Spazio tra i pulsanti
    }
};

const InserimentoRuolo = ({user}) => {
    const [titolo, setTitolo] = useState('');
    const [error, setError] = useState(null);
    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });
    const [open, setOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false); // Aggiunto per UX durante il salvataggio
    const navigate = useNavigate();

    const closeAlert = () => setOpen(false);

    // La logica di funzionamento rimane invariata
    const handleConferma = async (e) => {
        e.preventDefault();

        setAlert({ visible: false, type: '', message: '' });
        setOpen(false);
        setIsSaving(true); // Disabilita il pulsante

        try {


            const response = await fetch(
                `${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/add/ruolo`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ titolo, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente})
                }
            );

            if(response.status === 401){

                const datasResponse = await response.json();

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                setError("Errore di comunicazione con il server.");
                setOpen(true);
                return ;

            }

            if (!response.ok) {
                // Gestione più specifica dell'errore HTTP
                const errorData = await response.text();
                setError(`Errore nella chiamata al server`);
                setOpen(true);
                return;
            }

            const result = await response.json();

            if (result.esito === "OK") {
                navigate('/private/elencoRuoli', { state: { esito: result } });
            } else {
                setError(`Operazione fallita`);
                setOpen(true);
            }

        } catch (err) {
            setError("Errore di rete o server non raggiungibile.");
            setOpen(true);
        } finally {
            setIsSaving(false); // Riabilita il pulsante
        }
    };

    return (
        <Container className="bg-white py-lg-5 py-lg-6 ">
            <div className={"py-lg-6 py-lg-5"}>
                <Row className="justify-content-center">
                    <Col md={8} lg={8}>
                        <div style={styles.formContainer} className={"py-lg-5"}>
                            <h2 style={styles.formTitle}>Inserimento nuovo Ruolo</h2>

                            {error && open && (
                                <Alert color="danger" isOpen={open} toggle={closeAlert} className="mb-4">
                                    {error}
                                </Alert>
                            )}

                            <form onSubmit={handleConferma}>
                                <TextArea
                                    id="titolo"

                                    value={titolo}
                                    onChange={(e) => setTitolo(e.target.value)}
                                    rows={6} // Aumentato a 4 per coerenza con il form di modifica
                                    required={true}
                                    maxLength={230}
                                    placeholder="Esempio: Amministratore di sistema"
                                />

                                <div className="mt-4 mb-3" style={styles.buttonGroup}>
                                    <Button className="btn btn-outline-secondary" outline onClick={() => navigate('/private/elencoRuoli')}>
                                        Annulla
                                    </Button>
                                    <Button
                                        className="btn btn-outline-primary"
                                        type="submit"
                                        disabled={isSaving}
                                    >
                                        {isSaving ? 'Salvataggio...' : 'Conferma'}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </Col>
                </Row>
            </div>
        </Container>
    );
};

export default InserimentoRuolo;